import Box from "@mui/material/Box";
import { Button } from "react-admin";
import CancelIcon from "@mui/icons-material/Cancel";
import { TheoryLesson } from "../../model/autovioCalendarEvents";
import { Row } from "../../misc/Row";
import { InstructorInput } from "../../inputs/InstructorInput";
import { DateTimeInput } from "../../inputs/DateTimeInput";
import { Column } from "../../misc/Column";
import { autovioColors } from "../../misc/backofficeTheme";
import { grants } from "../../backoffice.access_control";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import { SaveButton2 } from "../../buttons/SaveButton2";
import { EditForm2 } from "../../misc/EditForm2";
import { TheoryLectureInput } from "../../inputs/TheoryLectureInput";

interface EditTheoryLessonFormProps {
  event: TheoryLesson;
  closeEditMode: () => void;
  openCancelDialog: () => void;
}

export const EditTheoryLessonForm = ({ event, closeEditMode, openCancelDialog }: EditTheoryLessonFormProps) => {
  const showCancelButton = grants.has("calendarEventEdit") || grants.has("TheoryLesson:edit");

  return (
    <EditForm2 resource="theoryLessons" id={event.id} onSuccess={closeEditMode}>
      <Box sx={{ minWidth: "450px" }}>
        <Column sx={{ gap: "20px" }}>
          <TheoryLectureInput
            label="Lektion"
            source="theoryLectureAbbreviation"
            category={event.theoryLecture.category}
            size="small"
          />
          <DateTimeInput allowPastDates source="start" sx={{ mt: "5px" }} size="small" />
          <InstructorInput source="instructorId" size="small" />
        </Column>
        <Row sx={{ pt: 1, justifyContent: "space-between", mt: "20px" }}>
          <Button
            startIcon={<NavigateBeforeIcon />}
            label="Zurück"
            variant="outlined"
            size="medium"
            onClick={closeEditMode}
          />
          <Row sx={{ gap: 2 }}>
            {showCancelButton && (
              <Button
                variant="outlined"
                size="medium"
                sx={{ borderColor: autovioColors.red, color: autovioColors.red }}
                startIcon={<CancelIcon />}
                onClick={openCancelDialog}
                label="Termin absagen"
              />
            )}
            <SaveButton2 />
          </Row>
        </Row>
      </Box>
    </EditForm2>
  );
};
